module.exports = __webpack_public_path__ + "static/media/01_central.c916cd5f.jpg";